(function () {
  var SECTION_SELECTOR = '.oddit-section-brand-story';
  var sectionState = new Map();

  function initMarquee(marquee) {
    var track = marquee.querySelector('[data-marquee-track]');
    var firstSet = marquee.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = window.getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    measure();

    var ro = new ResizeObserver(function () {
      measure();
    });
    ro.observe(marquee);
    ro.observe(firstSet);

    return { ro: ro, track: track };
  }

  function destroyMarquees(states) {
    if (!states) return;
    for (var i = 0; i < states.length; i++) {
      if (states[i] && states[i].ro) states[i].ro.disconnect();
    }
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;
    var marquees = section.querySelectorAll('[data-marquee]');
    var states = [];
    for (var i = 0; i < marquees.length; i++) {
      var state = initMarquee(marquees[i]);
      if (state) states.push(state);
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setPlayState(playState) {
      for (var i = 0; i < states.length; i++) {
        states[i].track.style.animationPlayState = playState;
      }
    }

    if (reducedMotion.matches) {
      setPlayState('paused');
    }

    function handleMotionChange(e) {
      setPlayState(e.matches ? 'paused' : 'running');
    }

    function handleVisibility() {
      if (reducedMotion.matches) return;
      setPlayState(document.hidden ? 'paused' : 'running');
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleMotionChange);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(handleMotionChange);
    }

    document.addEventListener('visibilitychange', handleVisibility);

    sectionState.set(section, {
      states: states,
      reducedMotion: reducedMotion,
      handleMotionChange: handleMotionChange,
      handleVisibility: handleVisibility
    });
  }

  function destroySection(section) {
    if (!section) return;
    var data = sectionState.get(section);
    if (!data) return;
    destroyMarquees(data.states);
    if (data.reducedMotion.removeEventListener) {
      data.reducedMotion.removeEventListener('change', data.handleMotionChange);
    } else if (data.reducedMotion.removeListener) {
      data.reducedMotion.removeListener(data.handleMotionChange);
    }
    document.removeEventListener('visibilitychange', data.handleVisibility);
    sectionState.delete(section);
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target && e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
    if (section) destroySection(section);
  });
})();